
// 慣性スクロール // Inertia (smooth) scrolling
// CDNで読み込んだ Lenis を初期化し、window.lenis として他のスクリプトから使えるようにする
// Initialize the CDN-loaded Lenis and expose it as window.lenis so the other scripts can use it

(function () {

	// Lenisが読み込めていない時は何もしない（通常のスクロールのまま）
	// Do nothing when Lenis is not available, leaving the native scrolling as is
	if (typeof window.Lenis === 'undefined') {
		return;
	}

	// OSで「視差効果を減らす」が有効な時は慣性スクロールを使わない
	// Skip the inertia scrolling when the user prefers reduced motion
	if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
		return;
	}

	var lenis = new window.Lenis({
		duration: 1.2,      // 慣性の長さ（秒）。大きいほどゆっくり止まる // Length of the inertia in seconds. The larger, the slower it stops
		wheelMultiplier: 1, // ホイール1回あたりの移動量 // Scroll amount per wheel notch
		smoothWheel: true,  // ホイール・トラックパッドを慣性スクロールにする // Apply inertia to wheel and trackpad
		syncTouch: false,   // スマホ・タブレットは端末標準のスクロールのまま // Keep native scrolling on touch devices
		easing: function (t) {
			return Math.min(1, 1.001 - Math.pow(2, -10 * t));
		}
	});

	// アンカーリンクやドロワーから制御できるように公開する
	// Expose it so the anchor links and the drawer can control it
	window.lenis = lenis;

	function raf(time) {
		lenis.raf(time);
		window.requestAnimationFrame(raf);
	}
	window.requestAnimationFrame(raf);

}());
